import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useLocation, useHistory } from "react-router-dom";
import { GoogleMap, LoadScript } from "@react-google-maps/api";
import { Marker } from "@react-google-maps/api";
//const ScriptLoaded = require("../../docs/ScriptLoaded").default;
import InputField from "../../components/InputField";
import picLeft from "../../assets/property/pic-left-dark.png";
import picLeftOn from "../../assets/property/pic-left-on-dark.png";
import picRight from "../../assets/property/pic-right-dark.png";
import picRightOn from "../../assets/property/pic-right-on-dark.png";

import iconLike from "../../assets/property/pic-icons/like.png";
import iconSave from "../../assets/property/pic-icons/save.png";
import iconShareLink from "../../assets/property/pic-icons/share-link.png";
import iconSharePdf from "../../assets/property/pic-icons/share-pdf.png";
import pencil from '../../assets/icons/pencil.png';

import bath from "../../assets/property/baths.png";

import eventsIcon from "../../assets/collections/icons/events.png";
import familyIcon from "../../assets/collections/icons/family.png";
import petsIcon from "../../assets/collections/icons/pets.png";
import sustainIcon from "../../assets/collections/icons/sustainable.png";

import ReactToPdf from "react-to-pdf";
import DatePickerArrival from "../../components/Forms/Fields/DatePickerArrival/DatePickerArrival";
import DatePickerDeparture from "../../components/Forms/Fields/DatePickerDeparture/DatePickerDeparture";
import PageHeader from "../../components/PageHeader";
import ImageWithHover from "../../components/ImageWithHover";
import {
  getStorageValue, isNullOrEmptyArray,
  calculateTotalNights,
  countWeekendDays,
  detectCurrency,
  isPercentage,
  isPercentageOrAmount
} from "../../Util/general";
import { PATH_LISTINGS, PATH_RESERVE } from "../../Util/constants";

import "./PropertyEdit.scss";
import Button from "../../components/Buttons/Button/Button";
import Row from "../../components/Row";
import UseCreateObject from "../../Hooks/UseCreateObject.jsx";
import goBack from "../../assets/go-back.svg";
import { baseURL } from "../../core";
import axios from "axios";
import EditPropDetails from "./EditDetails";
import Popup from "../../components/Popup";

const google = window.google;

const PropertyEdit = (props, propertyId) => {
  const [editDetails, setEditDetails] = useState(null);
  const [picIndex, setPicIndex] = useState(0);
  const dispatch = useDispatch();
  const { type, onBack } = props;
  const history = useHistory();
  const location = useLocation();
  const [loading, setLoading] = useState(false);
  const property = location.state && location.state.property;
  const ref = React.createRef();
  let prop = props;
  const AnyReactComponent = ({ text }) => <div>{text}</div>;

  useEffect(() => {
    const load = async () => { };

    load();
  }, []);
  console.log("please read property=", propertyId);

  console.log("current property:", property?.listing);
  const handleSend = async () => {
    try {
      setLoading(true);
      if (property?.listing) {
        setLoading(true);
        const payload = {
          title: property?.listing.title,
          guests: property?.listing.accommodates,
          bedrooms: property?.listing.bedrooms,
          bathrooms: property?.listing.bathrooms,
          overview: property?.listing.publicDescription?.summary,
          amenities: property?.listing.amenities,
          thumbnail: property?.listing.picture?.thumbnail,
          propertyPictures: property?.listing.pictures?.map((pic) => {
            return {
              thumbnail: `https://${pic?.thumbnail?.split("//")[1]}`,
              original: `https://${pic?.original?.split("//")[1]}`,
            };
          }),
          address: property?.listing?.address,
          logo: JSON.parse(localStorage.getItem("agent")).userImage,
          travelAgency: JSON.parse(localStorage.getItem("travelAgency")),
        };

        const pdf = await axios.post(`${baseURL}/pdf/generate`, payload, {
          responseType: "blob",
        });
        const blob = new Blob([pdf.data], { type: "application/pdf" });

        // Create a download link for the file
        const url = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.download = `${payload?.title}`;
        document.body.appendChild(link);
        link.click();

        // Clean up the object URL after the download is complete
        URL.revokeObjectURL(url);
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
    }
  };

  const setNextPic = () => {
    setPicIndex(picIndex + 1);
  };

  const setPrevPic = () => {
    let p = picIndex - 1;
    if (p < 0) {
      p += property?.listing?.pictures?.length;
    }
    setPicIndex(p);
  };

  const doSearch = (params) => {
    history.push(PATH_LISTINGS);
  };

  const doHold = (params) => {
    //console.log("go reserve!");
    history.push(PATH_RESERVE, { property });
  };

  if (property == null) {
    history.push(PATH_LISTINGS);
  }

  if (property) {
    //console.log("propertyData:", property);
    let searchPropertiesArray = [];
    let prop = UseCreateObject(property?.listing);
    //console.log("prop >>>: ", prop);
  }
  let pic = null;
  let picPosition = 0;

  if (!isNullOrEmptyArray(property?.listing?.pictures) && picIndex != null) {

    pic = property?.listing?.pictures[picIndex % property?.listing?.pictures?.length].original;
    picPosition = picIndex % property?.listing?.pictures?.length;
    //console.log(property?.listing?.pictures?.length, picIndex,pic);
  }

  const bullet = (index) => {
    return (
      <span
        key={index}
        style={{
          fontSize: "26px",
          color: index === picPosition ? "#44C8F5" : "#D1D1D1",
          padding: "0 3px",
        }}
      >
        &bull;
      </span>
    );
  };

  const renderAmenities = (text, i) => {
    return (
      <div key={i} className="property-page-body-top-left-info-amenity">
        {text}
      </div>
    );
  };

  const renderAmount = (title, pic, amount) => {
    return (
      <div className="property-page-body-top-left-info-amount">
        <img src={pic} alt="" style={{ width: "40px" }} />
        <span>{title}</span>
        {amount ? (
          <span style={{ fontSize: "20px" }}>{amount}</span>
        ) : (
          <span style={{ fontSize: "20px" }}>&nbsp;</span>
        )}
      </div>
    );
  };

  const amenities = property?.listing?.amenities;
  const summary = property?.listing?.publicDescription?.summary;
  prop = UseCreateObject(property?.listing);
  const mapContainerStyle = {
    height: "400px",
    width: "800px",
  };

  const center = {
    lat: prop.lat,
    lng: prop.lng,
  };

  const position = {
    lat: prop.lat,
    lng: prop.lng,
  };

  const onLoad = (marker) => {
    //console.log("position: ", position);
    //console.log("marker: ", marker);
  };

  return (
    <div className="property-page-wrapper">
      <PageHeader bgColor="#133B71" doSearch={doSearch} searchOpen={true} />
      <div
        className="link18-bold-no-line"
        style={{ display: "flex" }}
        onClick={doSearch}
      >
        <img src={goBack} alt="" />
        &nbsp;&nbsp;Back
      </div>
      {
        editDetails &&
        <Popup width={950} onClose={() => setEditDetails(null)}>
          <EditPropDetails pict={pic} formData={property} onClose={() => setEditDetails(null)} />
        </Popup>
      }
      <div ref={ref} className="edit-property-page-container">
      <div id="n_7_Web_1920X1080_Property_Request_a_Hold__2">
	<svg class="bg_inn">
		<rect id="bg_inn" rx="0" ry="0" x="0" y="0" width="1920" height="2792">
		</rect>
	</svg>
	<div id="Scroll_Group_2">
		<img id="screen_shot_2020_07__jk7r5" src="screen_shot_2020_07__jk7r5.png" srcset="screen_shot_2020_07__jk7r5.png 1x, screen_shot_2020_07__jk7r5@2x.png 2x"/>
	</div>
	<svg class="Bg_header" viewBox="0 0 1656.667 254.299">
		<path id="Bg_header" d="M 0 0 L 1656.666870117188 0 L 1656.666870117188 254.2987976074219 L 0 254.2987976074219 L 0 0 Z">
		</path>
	</svg>
	<div id="pdf_1">
		<div id="Group_602">
			<div id="Group_601">
				<svg class="Path_3022" viewBox="64 0 20.5 24.967">
					<path id="Path_3022" d="M 84.33268737792969 5.353904247283936 L 78.63835906982422 0.152387723326683 C 78.53158569335938 0.05485957860946655 78.38702392578125 0 78.23573303222656 0 L 66.27769470214844 0 C 65.02150726318359 0 64 0.9331004619598389 64 2.08061671257019 L 64 22.88663482666016 C 64 24.03410339355469 65.02150726318359 24.96720314025879 66.27774047851562 24.96720314025879 L 82.22181701660156 24.96720314025879 C 83.47800445556641 24.96720314025879 84.49951171875 24.03410339355469 84.49951171875 22.88658905029297 L 84.49951171875 5.721634387969971 C 84.49951171875 5.583486080169678 84.439453125 5.451433181762695 84.33268737792969 5.353904247283936 Z M 78.80519104003906 1.775841116905212 L 82.555419921875 5.201516628265381 L 79.94403076171875 5.201516628265381 C 79.31623840332031 5.201516628265381 78.80519104003906 4.73469877243042 78.80519104003906 4.161233425140381 L 78.80519104003906 1.775841116905212 Z M 83.36066436767578 22.88658905029297 C 83.36066436767578 23.46005249023438 82.84961700439453 23.92687034606934 82.22181701660156 23.92687034606934 L 66.27774047851562 23.92687034606934 C 65.64994049072266 23.92687034606934 65.13890075683594 23.46005249023438 65.13890075683594 22.88658905029297 L 65.13890075683594 2.08061671257019 C 65.13890075683594 1.507151126861572 65.64994049072266 1.040332555770874 66.27774047851562 1.040332555770874 L 77.66633605957031 1.040332555770874 L 77.66633605957031 4.161233425140381 C 77.66633605957031 5.308700561523438 78.68785095214844 6.241800785064697 79.94407653808594 6.241800785064697 L 83.36066436767578 6.241800785064697 L 83.36066436767578 22.88658905029297 Z">
					</path>
				</svg>
				<svg class="Path_3023" viewBox="128 170.666 13.666 13.666">
					<path id="Path_3023" d="M 137.7364654541016 178.2716064453125 C 137.2093048095703 177.8567657470703 136.7082824707031 177.4302673339844 136.3746337890625 177.0966186523438 C 135.9408874511719 176.6628723144531 135.5543823242188 176.2424621582031 135.2185516357422 175.8420867919922 C 135.7424011230469 174.2233123779297 135.9720764160156 173.3886566162109 135.9720764160156 172.9437561035156 C 135.9720764160156 171.0536346435547 135.2891845703125 170.666015625 134.2637634277344 170.666015625 C 133.4846801757812 170.666015625 132.5554809570312 171.0708312988281 132.5554809570312 172.9982604980469 C 132.5554809570312 173.8479766845703 133.0209350585938 174.8795166015625 133.9434661865234 176.0784149169922 C 133.7177124023438 176.7673950195312 133.4524536132812 177.5620727539062 133.1543884277344 178.4579162597656 C 133.0108947753906 178.8877563476562 132.855224609375 179.2859039306641 132.6905975341797 179.6540374755859 C 132.5566101074219 179.7135620117188 132.4264526367188 179.7741546630859 132.30078125 179.8369903564453 C 131.84814453125 180.0633392333984 131.4182891845703 180.2668304443359 131.0195617675781 180.4559173583984 C 129.2011413574219 181.3167419433594 128 181.8861846923828 128 183.0105743408203 C 128 183.826904296875 128.8869781494141 184.3323669433594 129.7082824707031 184.3323669433594 C 130.7670593261719 184.3323669433594 132.3658142089844 182.918212890625 133.5335845947266 180.5359344482422 C 134.7458343505859 180.0577239990234 136.2528686523438 179.7034759521484 137.4423217773438 179.4816131591797 C 138.3954467773438 180.2145080566406 139.4481201171875 180.915771484375 139.9580535888672 180.915771484375 C 141.3699493408203 180.915771484375 141.6663513183594 180.0994262695312 141.6663513183594 179.4148712158203 C 141.6663513183594 178.0685729980469 140.128173828125 178.0685729980469 139.3885955810547 178.0685729980469 C 139.158935546875 178.0686340332031 138.5428314208984 178.136474609375 137.7364654541016 178.2716064453125 Z M 129.7082824707031 183.1935119628906 C 129.3829650878906 183.1935119628906 129.1627502441406 183.0400390625 129.1388549804688 183.0105743408203 C 129.1388549804688 182.6068267822266 130.3427734375 182.0363006591797 131.5072326660156 181.4846954345703 C 131.5811767578125 181.4496765136719 131.6562805175781 181.4145965576172 131.7324523925781 181.3784484863281 C 130.877197265625 182.6185607910156 130.0313720703125 183.1935119628906 129.7082824707031 183.1935119628906 Z M 133.6943359375 172.9982604980469 C 133.6943359375 171.8049011230469 134.0647125244141 171.8049011230469 134.2637786865234 171.8049011230469 C 134.6664123535156 171.8049011230469 134.8332214355469 171.8049011230469 134.8332214355469 172.9437561035156 C 134.8332214355469 173.1839752197266 134.6730651855469 173.7845458984375 134.3799896240234 174.7221374511719 C 133.9328460693359 174.0337066650391 133.6943359375 173.4436950683594 133.6943359375 172.9982604980469 Z M 134.130859375 179.1185455322266 C 134.1664581298828 179.0195617675781 134.200927734375 178.9194641113281 134.2343139648438 178.8182678222656 C 134.4456024169922 178.184326171875 134.6358032226562 177.6148834228516 134.805419921875 177.1021728515625 C 135.041748046875 177.3624114990234 135.2964477539062 177.6287994384766 135.5695037841797 177.9018096923828 C 135.67626953125 178.0085754394531 135.9409484863281 178.2488098144531 136.2935485839844 178.5496215820312 C 135.5916442871094 178.7025756835938 134.8448638916016 178.8921966552734 134.130859375 179.1185455322266 Z M 140.5274963378906 179.4149322509766 C 140.5274963378906 179.6707458496094 140.5274963378906 179.7769317626953 139.9992065429688 179.7802886962891 C 139.8440704345703 179.7469329833984 139.4853820800781 179.5356292724609 139.042724609375 179.2342224121094 C 139.2033996582031 179.2164459228516 139.3218688964844 179.2075347900391 139.3885955810547 179.2075347900391 C 140.22998046875 179.2075347900391 140.4685668945312 179.289794921875 140.5274963378906 179.4149322509766 Z">
					</path>
				</svg>
			</div>
		</div>
	</div>

	<div id="Group_283">
		<img id="g916" src="g916.png" srcset="g916.png 1x, g916@2x.png 2x"/>
	</div>
	<div id="n_6">
		<span>16</span>
	</div>
	<div id="n_">
		<span>8</span>
	</div>
	<div id="n_0">
		<span>10</span>
	</div>
	<div id="g69">
		<div id="g71">
			<img id="g73" src="g73.png" srcset="g73.png 1x, g73@2x.png 2x"/>
		</div>
	</div>
	<div id="Layer_3">
		<div id="Group_282">
			<div id="ARC_423_">
				<div id="Group_264">
					<svg class="Path_2919" viewBox="48.815 38.382 17.71 5.033">
						<path id="Path_2919" d="M 50.97652435302734 43.41437911987305 C 49.91855621337891 43.41437911987305 48.99260711669922 42.96540832519531 48.83683013916016 42.34261703491211 C 48.66808319091797 41.65854263305664 49.48802947998047 41.02450561523438 50.67146301269531 40.92570495605469 C 55.11955261230469 40.55554580688477 59.38160705566406 39.75017929077148 63.34075927734375 38.52834701538086 C 64.40300750732422 38.20444869995117 65.70542907714844 38.43579864501953 66.27011108398438 39.0435905456543 C 66.83258819580078 39.652587890625 66.43238830566406 40.41170501708984 65.37873840332031 40.73685836791992 C 60.97391510009766 42.09374618530273 56.23159027099609 42.99042510986328 51.28805541992188 43.40311813354492 C 51.18201446533203 43.41060638427734 51.07818603515625 43.41437911987305 50.97652435302734 43.41437911987305 Z">
						</path>
					</svg>
				</div>
			</div>
			<div id="ARC_422_">
				<div id="Group_265">
					<svg class="Path_2920" viewBox="38.354 28.412 10.528 6.98">
						<path id="Path_2920" d="M 39.74503707885742 35.39175415039062 C 39.48347473144531 35.39175415039062 39.22055435180664 35.31801605224609 38.98682022094727 35.16637802124023 C 38.34268569946289 34.74621963500977 38.16043090820312 33.88505554199219 38.58056640625 33.24092864990234 C 40.55194854736328 30.21780395507812 43.88254547119141 28.41199493408203 47.49134826660156 28.41199493408203 C 48.26070785522461 28.41199493408203 48.88258743286133 29.03387069702148 48.88258743286133 29.80321884155273 C 48.88258743286133 30.57255554199219 48.26070785522461 31.19443130493164 47.49134826660156 31.19443130493164 C 44.82578659057617 31.19443130493164 42.36609268188477 32.52722549438477 40.91225814819336 34.76013565063477 C 40.64654541015625 35.16914749145508 40.20134735107422 35.39175415039062 39.74503707885742 35.39175415039062 Z">
						</path>
					</svg>
				</div>
			</div>
			<div id="CIRCLE_38_">
				<div id="Group_266">
					<svg class="Path_2921" viewBox="40.6 17.336 18.193 18.192">
						<path id="Path_2921" d="M 49.69718170166016 35.5275993347168 C 44.76530838012695 35.5275993347168 40.59998321533203 31.36229133605957 40.59998321533203 26.43179702758789 C 40.59998321533203 21.50130844116211 44.76530838012695 17.33599472045898 49.69718170166016 17.33599472045898 C 54.6276741027832 17.33599472045898 58.79299163818359 21.50130844116211 58.79299163818359 26.43179702758789 C 58.79299163818359 31.36229133605957 54.6276741027832 35.5275993347168 49.69718170166016 35.5275993347168 Z M 49.69718170166016 20.11843490600586 C 46.27479553222656 20.11843490600586 43.3824348449707 23.00939750671387 43.3824348449707 26.43179702758789 C 43.3824348449707 29.85419654846191 46.27477645874023 32.74515914916992 49.69718170166016 32.74515914916992 C 53.11959075927734 32.74515914916992 56.01055908203125 29.85419654846191 56.01055908203125 26.43179702758789 C 56.01055908203125 23.00939750671387 53.11959075927734 20.11843490600586 49.69718170166016 20.11843490600586 Z">
						</path>
					</svg>
				</div>
			</div>
			<div id="ARC_421_">
				<div id="Group_267">
					<svg class="Path_2922" viewBox="48.354 28.413 12.029 12.028">
						<path id="Path_2922" d="M 58.99127197265625 40.44148254394531 C 58.22193145751953 40.44148254394531 57.60006713867188 39.81961059570312 57.60006713867188 39.05027389526367 C 57.60006713867188 34.71939849853516 54.07608413696289 31.1954288482666 49.74520492553711 31.1954288482666 C 48.97586441040039 31.1954288482666 48.35398864746094 30.57354164123535 48.35398864746094 29.80421257019043 C 48.35398864746094 29.03485298156738 48.97586441040039 28.41299247741699 49.74520492553711 28.41299247741699 C 55.61060333251953 28.41299247741699 60.38250732421875 33.18627166748047 60.38250732421875 39.05027389526367 C 60.38250732421875 39.81820297241211 59.76063537597656 40.44148254394531 58.99127197265625 40.44148254394531 Z">
						</path>
					</svg>
				</div>
			</div>
			<div id="LINE_818_">
				<div id="Group_268">
					<svg class="Path_2923" viewBox="43.923 28.412 8.947 2.782">
						<path id="Path_2923" d="M 51.47871398925781 31.19443130493164 L 45.3141975402832 31.19443130493164 C 44.54486083984375 31.19443130493164 43.9229850769043 30.57255554199219 43.9229850769043 29.80321884155273 C 43.9229850769043 29.03387069702148 44.54486083984375 28.41199493408203 45.3141975402832 28.41199493408203 L 51.47871398925781 28.41199493408203 C 52.24805450439453 28.41199493408203 52.86992645263672 29.03387069702148 52.86992645263672 29.80321884155273 C 52.86992645263672 30.57255554199219 52.24665832519531 31.19443130493164 51.47871398925781 31.19443130493164 Z">
						</path>
					</svg>
				</div>
			</div>
			<div id="LINE_817_">
				<div id="Group_269">
					<svg class="Path_2924" viewBox="55 35.059 2.782 7.405">
						<path id="Path_2924" d="M 56.39119720458984 42.46447372436523 C 55.62184906005859 42.46447372436523 54.99998474121094 41.84260177612305 54.99998474121094 41.07325744628906 L 54.99998474121094 36.45022583007812 C 54.99998474121094 35.68085861206055 55.62184906005859 35.05899047851562 56.39119720458984 35.05899047851562 C 57.16055297851562 35.05899047851562 57.78242492675781 35.68085861206055 57.78242492675781 36.45022583007812 L 57.78242492675781 41.0732536315918 C 57.78242492675781 41.84260177612305 57.16055297851562 42.46446990966797 56.39119720458984 42.46446990966797 Z">
						</path>
					</svg>
				</div>
			</div>
			<div id="ARC_420_">
				<div id="Group_270">
					<svg class="Path_2925" viewBox="19.185 30.259 15.11 15.11">
						<path id="Path_2925" d="M 20.57621002197266 45.36905288696289 C 19.80686187744141 45.36905288696289 19.18499755859375 44.7471809387207 19.18499755859375 43.97782135009766 C 19.18499755859375 36.41237640380859 25.33975791931152 30.25899124145508 32.90382385253906 30.25899124145508 C 33.67317962646484 30.25899124145508 34.29505157470703 30.88087463378906 34.29505157470703 31.65021133422852 C 34.29505157470703 32.41956329345703 33.67317962646484 33.04144287109375 32.90382385253906 33.04144287109375 C 26.87287521362305 33.04144287109375 21.96744155883789 37.94688415527344 21.96744155883789 43.97782135009766 C 21.96744155883789 44.7471809387207 21.34416198730469 45.36905288696289 20.57621002197266 45.36905288696289 Z">
						</path>
					</svg>
				</div>
			</div>
			<div id="LINE_816_">
				<div id="Group_271">
					<svg class="Path_2926" viewBox="28.046 30.259 11.002 2.782">
						<path id="Path_2926" d="M 37.65654754638672 33.04144287109375 L 29.43720626831055 33.04144287109375 C 28.66786956787109 33.04144287109375 28.04598999023438 32.41956329345703 28.04598999023438 31.65021133422852 C 28.04598999023438 30.88087463378906 28.66786956787109 30.25899124145508 29.43720626831055 30.25899124145508 L 37.65654754638672 30.25899124145508 C 38.42588806152344 30.25899124145508 39.04776763916016 30.88087463378906 39.04776763916016 31.65021133422852 C 39.04776763916016 32.41956329345703 38.42588806152344 33.04144287109375 37.65654754638672 33.04144287109375 Z">
						</path>
					</svg>
				</div>
			</div>
			<div id="LINE_815_">
				<div id="Group_273">
					<svg class="Path_2928" viewBox="19.185 39.12 2.782 8.947">
						<path id="Path_2928" d="M 20.57621002197266 48.06693267822266 C 19.80686187744141 48.06693267822266 19.18499755859375 47.44504547119141 19.18499755859375 46.67570114135742 L 19.18499755859375 40.51120758056641 C 19.18499755859375 39.74187850952148 19.80686187744141 39.1199951171875 20.57621002197266 39.1199951171875 C 21.34556007385254 39.1199951171875 21.96744155883789 39.74187850952148 21.96744155883789 40.51120758056641 L 21.96744155883789 46.67570114135742 C 21.96744155883789 47.44504547119141 21.34416198730469 48.06693267822266 20.57621002197266 48.06693267822266 Z">
						</path>
					</svg>
				</div>
			</div>
			<div id="CIRCLE_37_">
				<div id="Group_274">
					<svg class="Path_2929" viewBox="23.615 15.489 23.331 23.331">
						<path id="Path_2929" d="M 35.2803840637207 38.81978225708008 C 28.95727920532227 38.81978225708008 23.61499214172363 33.47747421264648 23.61499214172363 27.15437698364258 C 23.61499214172363 20.83128356933594 28.95727920532227 15.4889965057373 35.2803840637207 15.4889965057373 C 41.60349655151367 15.4889965057373 46.94577789306641 20.83128356933594 46.94577789306641 27.15437698364258 C 46.94577789306641 33.47747421264648 41.60349655151367 38.81978225708008 35.2803840637207 38.81978225708008 Z M 35.2803840637207 18.27143096923828 C 30.46536636352539 18.27143096923828 26.39744567871094 22.33936309814453 26.39744567871094 27.15437698364258 C 26.39744567871094 31.96940040588379 30.46536636352539 36.03733062744141 35.2803840637207 36.03733062744141 C 40.09540557861328 36.03733062744141 44.16333770751953 31.96940040588379 44.16333770751953 27.15437698364258 C 44.16333770751953 22.33936309814453 40.09540557861328 18.27143096923828 35.2803840637207 18.27143096923828 Z">
						</path>
					</svg>
				</div>
			</div>
			<div id="ARC_418_">
				<div id="Group_275">
					<svg class="Path_2930" viewBox="33.954 30.259 15.11 15.11">
						<path id="Path_2930" d="M 47.67280197143555 45.36905288696289 C 46.90346527099609 45.36905288696289 46.28160858154297 44.7471809387207 46.28160858154297 43.97782135009766 C 46.28160858154297 37.94688415527344 41.37613677978516 33.04144287109375 35.3452033996582 33.04144287109375 C 34.57585525512695 33.04144287109375 33.9539909362793 32.41956329345703 33.9539909362793 31.65021133422852 C 33.9539909362793 30.88087463378906 34.57585525512695 30.25899124145508 35.3452033996582 30.25899124145508 C 42.91064071655273 30.25899124145508 49.06402587890625 36.41375350952148 49.06402587890625 43.97782135009766 C 49.06402587890625 44.7471809387207 48.44216537475586 45.36905288696289 47.67280197143555 45.36905288696289 Z">
						</path>
					</svg>
				</div>
			</div>
			<div id="LINE_814_">
				<div id="Group_276">
					<svg class="Path_2931" viewBox="42.815 39.12 2.782 8.947">
						<path id="Path_2931" d="M 44.20621109008789 48.06693267822266 C 43.43686294555664 48.06693267822266 42.81498718261719 47.44504547119141 42.81498718261719 46.67570114135742 L 42.81498718261719 40.51120758056641 C 42.81498718261719 39.74187850952148 43.43686294555664 39.1199951171875 44.20621109008789 39.1199951171875 C 44.97554779052734 39.1199951171875 45.59743499755859 39.74187850952148 45.59743499755859 40.51120758056641 L 45.59743499755859 46.67570114135742 C 45.59743499755859 47.44504547119141 44.97554779052734 48.06693267822266 44.20621109008789 48.06693267822266 Z">
						</path>
					</svg>
				</div>
			</div>
			<div id="ARC_417_">
				<div id="Group_277">
					<svg class="Path_2932" viewBox="19.184 43.551 35.661 6.901">
						<path id="Path_2932" d="M 37.0138053894043 50.45149230957031 C 31.14284896850586 50.45149230957031 25.27328491210938 49.02411651611328 19.92124938964844 46.17072296142578 C 19.24373626708984 45.80758666992188 18.98635292053223 44.96590042114258 19.34808158874512 44.28700637817383 C 19.71118545532227 43.61087417602539 20.5486946105957 43.3535041809082 21.23179244995117 43.71382522583008 C 31.11502838134766 48.98514175415039 42.91537094116211 48.98514175415039 52.79719161987305 43.71382522583008 C 53.47889709472656 43.3535041809082 54.31919097900391 43.61087417602539 54.68091583251953 44.28700637817383 C 55.04264068603516 44.96454620361328 54.78525161743164 45.80758666992188 54.10773468017578 46.17072296142578 C 48.75432586669922 49.0227165222168 42.88475036621094 50.45149230957031 37.0138053894043 50.45149230957031 Z">
						</path>
					</svg>
				</div>
			</div>
		</div>
	</div>
	<div id="Bathroom">
		<span>Bathroom</span>
	</div>
	<div id="Bedrooms">
		<span>Bedrooms</span>
	</div>
	<div id="Guests">
		<span>Guests</span>
	</div>
	<div id="g815">
		<img id="g817" src="g817.png" srcset="g817.png 1x, g817@2x.png 2x"/>
	</div>
	<div id="Event_Places">
		<span>Event Places</span>
	</div>
	<div id="Guesty_TAG">
		<span>Guesty TAG</span>
	</div>
	<div id="X_TAG">
		<span>X TAG</span>
	</div>
	<div id="Family_friendly">
		<span>Family friendly</span>
	</div>
	<svg class="Path_3052" viewBox="0 -9 1091.5 2.517">
		<path id="Path_3052" d="M 1091.5 -9 L 0 -6.483189105987549">
		</path>
	</svg>
	<svg class="Path_3335" viewBox="0 -9 1589 3.664">
		<path id="Path_3335" d="M 1589 -9.000000953674316 L 0 -5.336040496826172">
		</path>
	</svg>

	<div id="Location">
		<span>Location</span>
	</div>
	<svg class="Path_3337" viewBox="0 -9 1088.115 2.5">
		<path id="Path_3337" d="M 1088.115234375 -9 L 0 -6.500154972076416">
		</path>
	</svg>
	<svg class="Path_3341" viewBox="0 -9 1095 2.516">
		<path id="Path_3341" d="M 1095 -9 L 0 -6.48433780670166">
		</path>
	</svg>
	<div id="channel">
		<span>channel</span>
	</div>
	<div id="xdatapmName">
		<span>xdata.pmName</span>
	</div>
	<div id="n_423425">
		<span>3423425</span>
	</div>
	<div id="n_id">
		<span>{property?.listing?._id}</span>
	</div>
	<div id="updatedAt">
		<span>{property?.listing?.lastUpdatedAt}</span>
	</div>
	<div id="xdataapprvedAt">
		<span>xdata.apprvedAt</span>
	</div>
	<div id="property_ID">
		<span>Shub ID</span>
	</div>
	<div id="Last_calendar_sync">
		<span>Last calendar sync</span>
	</div>
	<div id="Approved_at">
		<span>Approved at</span>
	</div>
	<div id="PM">
		<span>PM</span>
	</div>
	<div id="country">
		<span>country</span>
	</div>
	<div id="region">
		<span>region</span>
	</div>
	<div id="city">
		<span>city</span>
	</div>
	<div id="declined">
		<span>declined</span>
	</div>
	<div id="agent">
		<span>agent:</span>
	</div>
	<div id="reason">
		<span>reason:</span>
	</div>
	<div id="Israel">
		<span>{property?.xdata?.country}</span>
	</div>
	<div id="Coast_line">
		<span>{property?.xdata?.declineReason}</span>
	</div>
	<div id="Ceasaria">
		<span>{property?.xdata?.city}</span>
	</div>
	<div id="xdataagent">
		<span>{property?.xdata?.agent}</span>
	</div>
	<div id="Last_updated_At">
		<span>Last updated At:</span>
	</div>
	<div id="xdataupdatedAt">
		<span>{property?.listing?.lastUpdatedAt}</span>
	</div>
	<div id="xdatadeclineReason">
		<span>{property?.xdata?.declineReason}</span>
	</div>
	<div id="VT">
		<span>VT</span>
	</div>
	<div id="SH">
		<span>SH</span>
	</div>
	<div id="TL">
		<span>TL</span>
	</div>
	<svg class="Rectangle_672">
		<rect id="Rectangle_672" rx="0" ry="0" x="0" y="0" width="53" height="53">
		</rect>
	</svg>
	<svg class="Rectangle_675">
		<rect id="Rectangle_675" rx="0" ry="0" x="0" y="0" width="53" height="53">
		</rect>
	</svg>
	<svg class="Rectangle_673">
		<rect id="Rectangle_673" rx="0" ry="0" x="0" y="0" width="53" height="53">
		</rect>
	</svg>
	<svg class="Rectangle_674">
		<rect id="Rectangle_674" rx="0" ry="0" x="0" y="0" width="53" height="53">
		</rect>
	</svg>
	
	<svg class="V_VT" viewBox="-19070.5 -3585.65 64.652 63.95">
		<path id="V_VT" d="M -19070.5 -3585.64990234375 L -19030.06640625 -3521.699951171875 L -19005.84765625 -3558 L -19030.06640625 -3543 L -19070.5 -3585.64990234375 Z">
		</path>
	</svg>
	<svg class="V_SH" viewBox="-19070.5 -3585.65 64.652 63.95">
		<path id="V_SH" d="M -19070.5 -3585.64990234375 L -19030.06640625 -3521.699951171875 L -19005.84765625 -3558 L -19030.06640625 -3543 L -19070.5 -3585.64990234375 Z">
		</path>
	</svg>
	<svg class="V_TL" viewBox="-19070.5 -3585.65 64.652 63.95">
		<path id="V_TL" d="M -19070.5 -3585.64990234375 L -19030.06640625 -3521.699951171875 L -19005.84765625 -3558 L -19030.06640625 -3543 L -19070.5 -3585.64990234375 Z">
		</path>
	</svg>
	<div id="Group_1589">
		<div id="Calendar">
			<span>Calendar</span>
		</div>
		<div id="When_icon" class="When_icon">
			<svg class="Path_3010" viewBox="0 0.114 74.035 83.063">
				<path id="Path_3010" d="M 59.74119186401367 6.495100498199463 L 56.97970199584961 6.495100498199463 L 56.97970199584961 3.35865330696106 C 56.97970199584961 1.566630601882935 55.68553924560547 0.1139983236789703 54.08899688720703 0.1139983236789703 C 52.49246597290039 0.1139983236789703 51.19829559326172 1.566630601882935 51.19829559326172 3.35865330696106 L 51.19829559326172 6.495100498199463 L 22.83658599853516 6.495100498199463 L 22.83658599853516 3.35865330696106 C 22.83658599853516 1.566630601882935 21.54241752624512 0.1139983236789703 19.94588279724121 0.1139983236789703 C 18.34934234619141 0.1139983236789703 17.05517578125 1.566630601882935 17.05517578125 3.35865330696106 L 17.05517578125 6.495100498199463 L 14.29383373260498 6.495100498199463 C 6.412181377410889 6.495100498199463 2.288817449880298e-05 13.69239139556885 2.288817449880298e-05 22.53894424438477 L 2.288817449880298e-05 67.13317108154297 C 2.288817449880298e-05 75.97988128662109 6.412181377410889 83.17717742919922 14.29383373260498 83.17717742919922 L 59.74134063720703 83.17717742919922 C 67.62284088134766 83.17717742919922 74.03500366210938 75.97988128662109 74.03500366210938 67.13317108154297 L 74.03500366210938 22.53894996643066 C 74.03500366210938 13.69240093231201 67.62284088134766 6.495105266571045 59.74119186401367 6.495105266571045 Z M 14.29383373260498 12.98440647125244 L 17.05517578125 12.98440647125244 L 17.05517578125 19.31148719787598 C 17.05517578125 21.1035099029541 18.34934425354004 22.5561408996582 19.94588279724121 22.5561408996582 C 21.54241752624512 22.5561408996582 22.83658599853516 21.1035099029541 22.83658599853516 19.31148719787598 L 22.83658599853516 12.98440647125244 L 51.19843673706055 12.98440647125244 L 51.19843673706055 19.31148719787598 C 51.19843673706055 21.1035099029541 52.49261093139648 22.5561408996582 54.08913803100586 22.5561408996582 C 55.68568420410156 22.5561408996582 56.97985076904297 21.1035099029541 56.97985076904297 19.31148719787598 L 56.97985076904297 12.98440647125244 L 59.74134063720703 12.98440647125244 C 64.43497467041016 12.98440647125244 68.25360107421875 17.27059745788574 68.25360107421875 22.5389404296875 L 68.25360107421875 25.63855934143066 L 5.781431674957275 25.63855934143066 L 5.781431674957275 22.5389404296875 C 5.781431674957275 17.27059745788574 9.600052833557129 12.98440647125244 14.29383659362793 12.98440647125244 Z M 59.74119186401367 76.68785858154297 L 14.29383373260498 76.68785858154297 C 9.600050926208496 76.68785858154297 5.781430244445801 72.40167236328125 5.781430244445801 67.13317108154297 L 5.781430244445801 32.12787628173828 L 68.25360107421875 32.12787628173828 L 68.25360107421875 67.13317108154297 C 68.25360107421875 72.40167999267578 64.43497467041016 76.68785858154297 59.74119186401367 76.68785858154297 Z M 25.67915916442871 44.89023208618164 C 25.67915916442871 46.68225860595703 24.38499069213867 48.13489532470703 22.78845596313477 48.13489532470703 L 17.10345077514648 48.13489532470703 C 15.50691604614258 48.13489532470703 14.21274757385254 46.68225860595703 14.21274757385254 44.89023208618164 C 14.21274757385254 43.09820556640625 15.50691604614258 41.64557647705078 17.10345077514648 41.64557647705078 L 22.78845596313477 41.64557647705078 C 24.38484764099121 41.64557647705078 25.67915916442871 43.09820556640625 25.67915916442871 44.89023208618164 Z M 59.82241821289062 44.89023208618164 C 59.82241821289062 46.68225860595703 58.52825164794922 48.13489532470703 56.93171691894531 48.13489532470703 L 51.24670791625977 48.13489532470703 C 49.65017318725586 48.13489532470703 48.35600662231445 46.68225860595703 48.35600662231445 44.89023208618164 C 48.35600662231445 43.09820556640625 49.65017318725586 41.64557647705078 51.24670791625977 41.64557647705078 L 56.93171691894531 41.64557647705078 C 58.52811050415039 41.64557647705078 59.82241821289062 43.09820556640625 59.82241821289062 44.89023208618164 Z M 42.73431777954102 44.89023208618164 C 42.73431777954102 46.68225860595703 41.44014739990234 48.13489532470703 39.84361267089844 48.13489532470703 L 34.15860748291016 48.13489532470703 C 32.56207275390625 48.13489532470703 31.26790237426758 46.68225860595703 31.26790237426758 44.89023208618164 C 31.26790237426758 43.09820556640625 32.56207275390625 41.64557647705078 34.15860748291016 41.64557647705078 L 39.84361267089844 41.64557647705078 C 41.44000244140625 41.64557647705078 42.73431777954102 43.09820556640625 42.73431777954102 44.89023208618164 Z M 25.67915916442871 64.03370666503906 C 25.67915916442871 65.82572174072266 24.38499450683594 67.27835845947266 22.7884578704834 67.27835845947266 L 17.10345268249512 67.27835845947266 C 15.50691699981689 67.27835845947266 14.21275043487549 65.82572174072266 14.21275043487549 64.03370666503906 C 14.21275043487549 62.2416877746582 15.50691699981689 60.78905487060547 17.10345268249512 60.78905487060547 L 22.7884578704834 60.78905487060547 C 24.38484764099121 60.78905487060547 25.67915916442871 62.2416877746582 25.67915916442871 64.03370666503906 Z M 59.82241821289062 64.03370666503906 C 59.82241821289062 65.82572174072266 58.52825164794922 67.27835845947266 56.93171691894531 67.27835845947266 L 51.24670791625977 67.27835845947266 C 49.65017318725586 67.27835845947266 48.35600662231445 65.82572174072266 48.35600662231445 64.03370666503906 C 48.35600662231445 62.2416877746582 49.65017318725586 60.78905487060547 51.24670791625977 60.78905487060547 L 56.93171691894531 60.78905487060547 C 58.52811050415039 60.78905487060547 59.82241821289062 62.2416877746582 59.82241821289062 64.03370666503906 Z M 42.73431777954102 64.03370666503906 C 42.73431777954102 65.82572174072266 41.44014739990234 67.27835845947266 39.84361267089844 67.27835845947266 L 34.15860748291016 67.27835845947266 C 32.56207275390625 67.27835845947266 31.26790237426758 65.82572174072266 31.26790237426758 64.03370666503906 C 31.26790237426758 62.2416877746582 32.56207275390625 60.78905487060547 34.15860748291016 60.78905487060547 L 39.84361267089844 60.78905487060547 C 41.44000244140625 60.78905487060547 42.73431777954102 62.2416877746582 42.73431777954102 64.03370666503906 Z">
				</path>
			</svg>
		</div>
	</div>
	<div id="family">
		<div id="Group_253">
			<svg class="Path_2914" viewBox="29.71 7.13 11.275 11.275">
				<path id="Path_2914" d="M 35.35004425048828 7.130001068115234 C 32.23587036132812 7.128632545471191 29.71046257019043 9.652554512023926 29.71000862121582 12.76673793792725 C 29.71000862121582 15.88175296783447 32.23503112792969 18.40603065490723 35.34922027587891 18.40511512756348 C 38.46173858642578 18.40511512756348 40.98603057861328 15.88009548187256 40.98513031005859 12.76590728759766 C 40.98012542724609 9.655677795410156 38.46023559570312 7.13545036315918 35.35004425048828 7.130001068115234 Z M 35.35004425048828 16.67201614379883 C 33.19367980957031 16.67337799072266 31.44448280334473 14.92640590667725 31.4431324005127 12.7700366973877 C 31.44174766540527 10.61366367340088 33.18873596191406 8.864477157592773 35.34506988525391 8.86311149597168 C 37.50145721435547 8.861745834350586 39.25066375732422 10.60871887207031 39.25199890136719 12.76508617401123 C 39.24932098388672 14.91976070404053 37.50470733642578 16.66656112670898 35.35004425048828 16.67201614379883 Z">
				</path>
			</svg>
			<svg class="Path_2915" viewBox="73.74 7.13 11.275 11.275">
				<path id="Path_2915" d="M 79.37509155273438 7.130001068115234 C 76.26155090332031 7.131372451782227 73.73866271972656 9.656502723693848 73.74002838134766 12.77003765106201 C 73.74141693115234 15.88358020782471 76.26654815673828 18.4064884185791 79.38003540039062 18.40511703491211 C 82.49360656738281 18.40375709533691 85.01651763916016 15.87863254547119 85.01510620117188 12.76509571075439 C 85.00968933105469 9.65324592590332 82.48693084716797 7.132724761962891 79.37509155273438 7.1300048828125 Z M 79.37509155273438 16.67201614379883 C 77.21938323974609 16.6706485748291 75.47270202636719 14.92246913909912 75.47313690185547 12.76673793792725 C 75.47313690185547 10.61183547973633 77.22017669677734 8.86402702331543 79.37591552734375 8.86311149597168 C 81.53330993652344 8.86311149597168 83.28112030029297 10.61018943786621 83.28201293945312 12.76591300964355 C 83.27886962890625 14.92220211029053 81.53136444091797 16.66928672790527 79.37509155273438 16.67201614379883 Z">
				</path>
			</svg>
			<svg class="Path_2916" viewBox="18.62 31.85 45.331 42.978">
				<path id="Path_2916" d="M 63.86110687255859 48.58726501464844 L 62.03305816650391 39.06241607666016 C 61.22866058349609 34.88284301757812 57.45613098144531 31.85131454467773 53.05778503417969 31.84999847412109 L 50.61542510986328 31.84999847412109 C 47.67498397827148 31.86174774169922 44.91790771484375 33.23277282714844 43.19843292236328 35.53829193115234 C 42.15802001953125 35.21144104003906 41.04105377197266 35.18794250488281 39.98688507080078 35.47068405151367 C 38.9480094909668 33.46723556518555 37.33476257324219 32.28931045532227 35.54670333862305 32.28931045532227 L 24.12405014038086 32.28931045532227 C 21.29709815979004 32.28931045532227 18.61999130249023 36.11279296875 18.61999130249023 40.15830993652344 L 18.61999130249023 52.27072525024414 C 18.62191581726074 53.80301666259766 19.90658187866211 55.04472732543945 21.49189567565918 55.04658889770508 C 21.83450508117676 55.04628372192383 22.17436408996582 54.9874382019043 22.49580383300781 54.87278366088867 L 21.78657150268555 70.31143951416016 C 21.69754791259766 72.21141052246094 22.9048900604248 73.94401550292969 24.75992584228516 74.57833862304688 C 26.61495590209961 75.21266174316406 28.68095970153809 74.59933471679688 29.84785270690918 73.06800842285156 C 30.61055564880371 74.07494354248047 31.78880882263184 74.71132659912109 33.07577514648438 74.81142425537109 C 34.36274719238281 74.91152191162109 35.63111114501953 74.46546936035156 36.55060958862305 73.58939361572266 C 37.10616683959961 74.27666473388672 37.92596435546875 74.71725463867188 38.82313919067383 74.81078338623047 C 39.8853874206543 74.91007995605469 40.93363952636719 74.51802062988281 41.65009307861328 73.75351715087891 C 42.38446044921875 74.54745483398438 43.47732543945312 74.939208984375 44.5696907043457 74.80010223388672 C 45.66203308105469 74.66099548339844 46.61262893676758 74.00902557373047 47.10919189453125 73.05831909179688 C 47.46782684326172 73.93051147460938 48.25471496582031 74.57103729248047 49.20492553710938 74.76424407958984 C 50.15514373779297 74.95745849609375 51.14231109619141 74.67763519287109 51.83407592773438 74.01902008056641 C 52.63531494140625 74.78009033203125 53.81838226318359 75.02709197998047 54.8731803894043 74.65355682373047 C 55.92796325683594 74.28001403808594 56.66589736938477 73.35268402099609 56.76876449584961 72.27144622802734 L 58.02240753173828 58.99557495117188 L 60.83937072753906 58.99557495117188 C 61.09127044677734 58.99518585205078 61.33084869384766 58.89017486572266 61.49714660644531 58.70726776123047 C 61.66343688964844 58.52436828613281 61.74038696289062 58.28118896484375 61.70841217041016 58.03969573974609 L 61.16900634765625 54.05694198608398 C 63.19704437255859 52.98950576782227 64.28374481201172 50.78158187866211 63.86109161376953 48.58725357055664 Z M 41.47029113769531 36.96723937988281 C 43.64533233642578 36.96858978271484 45.40740966796875 38.67391586303711 45.40604019165039 40.77619934082031 C 45.40465545654297 42.87853240966797 43.64033126831055 44.58169174194336 41.46530532836914 44.58036804199219 C 39.2902717590332 44.57904434204102 37.5281867980957 42.87371826171875 37.52955627441406 40.77139663696289 C 37.53037643432617 38.66886138916016 39.29503631591797 36.96538543701172 41.47027969360352 36.96723937988281 Z M 47.31398010253906 60.5404052734375 C 47.31398010253906 60.89766693115234 47.01434326171875 61.18729400634766 46.64470291137695 61.18729400634766 C 46.16220855712891 61.18780517578125 45.77120590209961 61.56575012207031 45.77064514160156 62.03211975097656 L 45.77064514160156 71.46524047851562 C 45.79345703125 72.29716491699219 45.16519927978516 73.01255035400391 44.31222152709961 73.12593841552734 C 43.8554573059082 73.17192840576172 43.39997863769531 73.02836608886719 43.05902862548828 72.73106384277344 C 42.71806716918945 72.43370819091797 42.52367401123047 72.01049041748047 42.5241584777832 71.56664276123047 L 42.5241584777832 62.76107788085938 C 42.5241584777832 62.29449462890625 42.1328125 61.91625213623047 41.65009307861328 61.91625213623047 C 41.1673583984375 61.91625213623047 40.77605056762695 62.29449462890625 40.77605056762695 62.76107788085938 L 40.77605056762695 71.56664276123047 C 40.77779769897461 72.01000213623047 40.5844841003418 72.43319702148438 40.24433517456055 72.73068237304688 C 39.90416717529297 73.02817535400391 39.44922256469727 73.17183685302734 38.99296569824219 73.12593841552734 C 38.13893508911133 73.01310729980469 37.5088996887207 72.29817199707031 37.52955627441406 71.46524047851562 L 37.52954864501953 62.03211975097656 C 37.53009033203125 61.80789947509766 37.43817138671875 61.59272003173828 37.27413940429688 61.43417358398438 C 37.11010360717773 61.27561950683594 36.88747406005859 61.18677520751953 36.65549087524414 61.18729400634766 L 36.29088973999023 61.18729400634766 C 35.92206192016602 61.18545532226562 35.62351608276367 60.89690399169922 35.62162017822266 60.5404052734375 L 35.62162017822266 54.46729278564453 C 35.61984252929688 53.97987365722656 35.68534469604492 53.49447250366211 35.81640625 53.02383422851562 C 36.56023025512695 50.27199554443359 39.30493545532227 48.48398590087891 42.22301483154297 48.85033416748047 C 45.14109802246094 49.21669387817383 47.32217788696289 51.62306976318359 47.31398010253906 54.46729278564453 L 47.31398010253906 60.5404052734375 Z M 50.96005249023438 72.01557159423828 C 50.95949172973633 72.63393402099609 50.44103240966797 73.13505554199219 49.80129623413086 73.13559722900391 C 49.20277786254883 73.13144683837891 48.70341110229492 72.69251251220703 48.64255142211914 72.11693572998047 L 47.74351119995117 62.61626434326172 C 48.54959487915039 62.21656799316406 49.05807113647461 61.41603088378906 49.06208419799805 60.5404052734375 L 49.06208419799805 58.99557495117188 L 50.96005249023438 58.99557495117188 L 50.96005249023438 72.01557159423828 Z M 55.0256462097168 72.11697387695312 C 54.96821975708008 72.71353912353516 54.43612670898438 73.16135406494141 53.81687545776367 73.13428497314453 C 53.19765090942383 73.107177734375 52.70958709716797 72.61473846435547 52.70813369750977 72.01557159423828 L 52.70813369750977 58.99557495117188 L 56.26931381225586 58.99557495117188 L 55.0256462097168 72.11697387695312 Z M 60.83937072753906 52.24658584594727 L 58.08235549926758 38.9803581237793 C 57.98717880249023 38.52312850952148 57.52653503417969 38.22699737548828 57.05347061157227 38.31899642944336 C 56.58038711547852 38.41094589233398 56.27402114868164 38.85620880126953 56.36921310424805 39.31346130371094 C 56.39417266845703 39.44380569458008 56.41912460327148 39.55484008789062 56.43911743164062 39.64656829833984 C 56.43880081176758 39.65488815307617 56.44049835205078 39.66315460205078 56.44411468505859 39.67070770263672 C 56.44411468505859 39.68035125732422 56.44911193847656 39.69485473632812 56.44911193847656 39.70448684692383 C 56.449462890625 39.70821762084961 56.45128631591797 39.71163177490234 56.45410919189453 39.71414947509766 C 56.45333862304688 39.72249984741211 56.4550666809082 39.73088455200195 56.45912170410156 39.73828887939453 C 56.45912170410156 39.75278091430664 56.46409606933594 39.76725769042969 56.46409606933594 39.7817497253418 C 56.46909332275391 39.78655624389648 56.46909332275391 39.79139709472656 56.46909332275391 39.80104827880859 C 56.46909332275391 39.81071090698242 56.47406387329102 39.82516860961914 56.47907638549805 39.83968734741211 C 56.48408889770508 39.87347030639648 56.49405670166016 39.90243911743164 56.49905395507812 39.9410514831543 C 56.49905395507812 39.95071411132812 56.50405120849609 39.96035766601562 56.50405120849609 39.97002029418945 C 56.50766372680664 39.97757339477539 56.50937652587891 39.98583984375 56.50904846191406 39.99416732788086 C 56.5142936706543 40.00981140136719 56.51766204833984 40.02601623535156 56.51903533935547 40.04242706298828 C 56.52285385131836 40.04629516601562 56.52468490600586 40.05158996582031 56.52402114868164 40.05691909790039 C 56.74380111694336 41.11896896362305 57.43804168701172 44.46450042724609 59.3609733581543 53.718994140625 L 59.84546661376953 57.30592346191406 L 49.06208419799805 57.30592346191406 L 49.06208419799805 54.46729278564453 C 49.06208419799805 50.41332626342773 45.66201019287109 47.12691497802734 41.46780395507812 47.12691497802734 C 37.27360916137695 47.12691497802734 33.87350463867188 50.41332626342773 33.87350463867188 54.46729278564453 L 33.87350463867188 60.5404052734375 C 33.87514877319336 61.64038848876953 34.66922378540039 62.59078216552734 35.78144454956055 62.82384490966797 C 35.79143905639648 71.90939331054688 35.76645278930664 71.46524047851562 35.80142974853516 71.80318450927734 C 35.19364547729492 72.84230041503906 33.93700408935547 73.35417175292969 32.74307250976562 73.04897308349609 C 31.54915809631348 72.74372100830078 30.71867179870605 71.69825744628906 30.72191429138184 70.50454711914062 L 30.72191429138184 53.5597038269043 C 30.72192192077637 53.09310913085938 30.3305835723877 52.7148551940918 29.84785652160645 52.7148551940918 C 29.36514091491699 52.7148551940918 28.97381019592285 53.09310913085938 28.97381019592285 53.5597038269043 L 28.97380638122559 70.51903533935547 C 28.93720817565918 71.97116851806641 27.68913269042969 73.11915588378906 26.18680953979492 73.08311462402344 C 24.68446731567383 73.04713439941406 23.49677467346191 71.84078979492188 23.53402709960938 70.38869476318359 L 24.35380172729492 52.50730895996094 C 24.35380172729492 52.45417404174805 24.35880088806152 42.68314361572266 24.36379051208496 39.71899032592773 C 24.36379051208496 39.25239562988281 23.97246742248535 38.87417984008789 23.48973846435547 38.87417984008789 C 23.00699996948242 38.87417984008789 22.61568069458008 39.25239562988281 22.61568069458008 39.71899032592773 L 22.60568618774414 52.41072845458984 C 22.5307788848877 52.97967529296875 22.01096534729004 53.39418411254883 21.41882514953613 53.35711669921875 C 20.82668685913086 53.32009506225586 20.36650085449219 52.84426498413086 20.36811637878418 52.27074432373047 L 20.36811637878418 40.15832138061523 C 20.36811637878418 36.88999557495117 22.4708423614502 33.97899627685547 24.12405776977539 33.97899627685547 L 35.54671096801758 33.97899627685547 C 36.61055374145508 33.97899627685547 37.6594123840332 34.79965972900391 38.38861846923828 36.16104125976562 C 37.35154724121094 36.80904769897461 36.55949401855469 37.76430892944336 36.13106536865234 38.88380813598633 C 35.1152229309082 41.55401992797852 36.37545776367188 44.53217697143555 39.03611373901367 45.74892807006836 C 41.69676971435547 46.96563339233398 44.87829971313477 46.01875686645508 46.37002944946289 43.56618881225586 C 47.86175537109375 41.11362075805664 47.17057418823242 37.96610260009766 44.7767333984375 36.31070709228516 C 46.17970275878906 34.56974029541016 48.3322868347168 33.5481071472168 50.61542510986328 33.53966522216797 L 53.05778503417969 33.53966522216797 C 56.61299514770508 33.5438232421875 59.66153335571289 35.99360275268555 60.31491851806641 39.37141036987305 L 62.14295959472656 48.896240234375 C 62.38407897949219 50.16022109985352 61.88246154785156 51.44944000244141 60.83937072753906 52.24658584594727 Z">
				</path>
			</svg>
		</div>
	</div>
	<div id="Group_368">
		<svg class="Ellipse_17">
			<ellipse id="Ellipse_17" rx="41.24555206298828" ry="41.24555206298828" cx="41.24555206298828" cy="41.24555206298828">
			</ellipse>
		</svg>
		<div id="g2414">
			<img id="g2416" src="g2416.png" srcset="g2416.png 1x, g2416@2x.png 2x"/>
		</div>
	</div>
	<div id="Group_1161">
		<svg class="Ellipse_18">
			<ellipse id="Ellipse_18" rx="41.24555206298828" ry="41.24555206298828" cx="41.24555206298828" cy="41.24555206298828">
			</ellipse>
		</svg>
		<div id="Group_360">
			<div id="plant">
				<div id="Group_248">
					<div id="Group_247">
						<svg class="Path_2911" viewBox="0 21.579 21.089 21.088">
							<path id="Path_2911" d="M 18.61745834350586 26.09139251708984 C 14.57185840606689 22.04784774780273 6.655113220214844 21.5789794921875 1.051393508911133 21.5789794921875 C 0.4710424244403839 21.5789794921875 0 22.04992294311523 0 22.63027954101562 C 0 28.2339916229248 0.4668041467666626 36.15074157714844 4.512406349182129 40.19644165039062 C 6.219850063323975 41.90388107299805 8.837738037109375 42.66719055175781 11.43246269226074 42.66719055175781 C 14.25221252441406 42.66719055175781 17.04673004150391 41.76511383056641 18.61746215820312 40.19437026977539 C 21.63069725036621 37.1811408996582 22.18374252319336 29.6555004119873 18.61745834350586 26.09139251708984 Z M 17.13090515136719 38.70978927612305 C 14.88095855712891 40.95756912231445 8.633806228637695 41.34235763549805 6.001232147216797 38.70978927612305 C 2.735673427581787 35.44433212280273 2.170008420944214 28.81020927429199 2.108996868133545 23.68797302246094 C 7.231225490570068 23.74899864196777 13.8653450012207 24.31455230712891 17.13080596923828 27.58011436462402 C 19.76347732543945 30.21268653869629 19.37868118286133 36.46200561523438 17.13090515136719 38.70978927612305 Z">
							</path>
						</svg>
					</div>
				</div>
				<div id="Group_250">
					<div id="Group_249">
						<svg class="Path_2912" viewBox="255.862 63.776 21.089 21.086">
							<path id="Path_2912" d="M 275.8997802734375 63.77602005004883 C 270.2960205078125 63.77602005004883 262.3793334960938 64.24278259277344 258.3335571289062 68.28839111328125 C 254.7674560546875 71.85250854492188 255.3203125 79.37815856933594 258.3335571289062 82.391357421875 C 259.9043579101562 83.96003723144531 262.69677734375 84.86210632324219 265.5166931152344 84.86210632324219 C 268.1112670898438 84.86210632324219 270.7272338867188 84.10089111328125 272.4387512207031 82.39353942871094 C 276.4823303222656 78.34794616699219 276.9512023925781 70.43119812011719 276.9512023925781 64.82737731933594 C 276.9512023925781 64.24705505371094 276.4801940917969 63.77602005004883 275.8997802734375 63.77602005004883 Z M 270.9478454589844 80.90470886230469 C 268.3153991699219 83.53727722167969 262.0661315917969 83.15249633789062 259.8182678222656 80.90470886230469 C 257.5705261230469 78.65695190429688 257.1857299804688 72.40760803222656 259.8182678222656 69.7750244140625 C 263.0838012695312 66.50946044921875 269.7177124023438 65.94392395019531 274.8400573730469 65.88290405273438 C 274.7791442871094 71.00721740722656 274.2134399414062 77.64131164550781 270.9478454589844 80.90470886230469 Z">
							</path>
						</svg>
					</div>
				</div>
				<div id="Group_252">
					<div id="Group_251">
						<svg class="Path_2913" viewBox="85.328 106.928 29.373 33.642">
							<path id="Path_2913" d="M 114.5816040039062 111.7753677368164 C 114.33349609375 111.2475204467773 113.6227874755859 111.066764831543 113.0991668701172 111.3106460571289 C 105.0353012084961 115.1018142700195 101.0737609863281 121.7128067016602 99.27376556396484 128.5087890625 C 97.04698944091797 114.0587844848633 90.60635375976562 109.6536636352539 87.87494659423828 107.7843551635742 C 87.53427124023438 107.5509567260742 87.26932525634766 107.3806381225586 87.12217712402344 107.2355422973633 C 86.71213531494141 106.8255233764648 86.04556274414062 106.8255233764648 85.63551330566406 107.2355422973633 C 85.22547912597656 107.6455764770508 85.22547912597656 108.3121871948242 85.63551330566406 108.7222061157227 C 85.84367370605469 108.9283065795898 86.20323944091797 109.1869277954102 86.68900299072266 109.5191268920898 C 89.76736450195312 111.6239700317383 97.94481658935547 117.2193069458008 97.94481658935547 139.5187072753906 C 97.94481658935547 140.0990295410156 98.41584014892578 140.5700378417969 98.9962158203125 140.5700378417969 C 99.57656097412109 140.5700378417969 100.0476150512695 140.0990295410156 100.0476150512695 139.5208435058594 C 100.0476150512695 130.5107116699219 102.4678726196289 118.6324234008789 113.9949188232422 113.2158126831055 C 113.9949188232422 113.2137069702148 114.1652679443359 113.1337966918945 114.1652679443359 113.1337966918945 C 114.6888580322266 112.885612487793 114.8297271728516 112.3009872436523 114.5816040039062 111.7753677368164 Z">
							</path>
						</svg>
					</div>
				</div>
			</div>
		</div>
	</div>
	<svg class="Rectangle_695">
		<rect id="Rectangle_695" rx="0" ry="0" x="0" y="0" width="262" height="64">
		</rect>
	</svg>
	<svg class="Rectangle_696">
		<rect id="Rectangle_696" rx="0" ry="0" x="0" y="0" width="262" height="64">
		</rect>
	</svg>
	<div id="SAVE">
		<span>SAVE</span>
	</div>
	<div id="Cancel">
		<span>Cancel</span>
	</div>
</div>
        <div className="edit-property-main-top">

          <div className="edit-property-main-picture-container">
          <div />
              <ImageWithHover
                path={picLeft}
                pathOver={picLeftOn}
                className="property-page-prev-next-pic"
                style={{ left: "10px" }}
                onClick={setPrevPic}
              />
              <div
                className="edit-property-main-picture"
                style={{
                  backgroundImage: pic ? `url(${pic})` : "transparent",
                  backgroundSize: "cover", left: "210px",
                }}
              />
              <ImageWithHover
                path={picRight}
                pathOver={picRightOn}
                className="edit-property-page-prev-next-pic"
                style={{ right: "10px" }}
                onClick={setNextPic}
              />
              <div />
              
            <div className="edit-property-main-picture-icons">
              <img
                className="edit-property-main-picture-icon"
                src={pencil}
                onClick={() => setEditDetails(true)}
                alt="EDIT PROPERTY"
              />
              <img
                className="edit-property-main-picture-icon"
                src={iconShareLink}
                alt=""
              />
              {/*
              <ReactToPdf
                targetRef={ref}
                scale={0.65}
                filename="villa-tracker.pdf"
              >
                {({ toPdf }) => (
                  <img
                    onClick={toPdf}
                    className="property-main-picture-icon"
                    src={iconSharePdf}
                    alt=""
                  />
                )}
              </ReactToPdf>
                */}
              <img
                className="edit-property-main-picture-icon"
                src={iconSharePdf}
                alt=""
                disabled={loading}
                onClick={handleSend}
              />
              <img
                className="edit-property-main-picture-icon"
                src={iconLike}
                alt=""
              />

            </div>
          </div>
          <div className="edit-property-main-picture-bullets">
            {property?.listing &&
              property?.listing?.pictures &&
              !isNullOrEmptyArray(property?.listing?.pictures) &&
              property?.listing?.pictures.map((pic, i) => bullet(i))}
          </div>
        </div>
<div>
        <div className="property-page-body-top">
          <div className="property-page-body-top-left">
            <div className="property-page-body-top-title">{property?.listing?.title}</div>
            <div className="property-page-body-top-subtitle">
              {prop.fullAddress}
            </div>

            <div className="property-page-body-top-left-info">
              <hr style={{ color: "#E7E7E7" }} />

              <Row>
                {renderAmount("Guests", bath, prop.accommodates)}
                {renderAmount("Bedrooms", bath, prop.bedrooms)}
                {renderAmount("Bathrooms", bath, prop.bathrooms)}

                {prop.tags.indexOf("eventCollection") > -1
                  ? renderAmount("Event Places", eventsIcon)
                  : ""}
                {prop.tags.indexOf("familyCollection") > -1
                  ? renderAmount("For Families", familyIcon)
                  : ""}
                {prop.tags.indexOf("petsCollection") > -1
                  ? renderAmount("Pets Welcome", petsIcon)
                  : ""}
                {prop.tags.indexOf("sustainCollection") > -1
                  ? renderAmount("Sustainable", sustainIcon)
                  : ""}
              </Row>

              <hr style={{ color: "#E7E7E7" }} />

              <div style={{ fontSize: "25px", fontWeight: "bold" }}>
                Overview
              </div>
              <ul>
                <li style={{ paddingTop: "10px" }}>{summary}</li>
              </ul>

              <hr style={{ color: "#E7E7E7" }} />

              <div style={{ fontSize: "25px", fontWeight: "bold" }}>
                Amenities
              </div>

              <div className="property-page-body-top-left-info-amenities">
                {amenities.map((a, i) => renderAmenities(a, i))}
              </div>

              <hr style={{ color: "#E7E7E7" }} />

              <div
                style={{
                  fontSize: "25px",
                  fontWeight: "bold",
                  paddingBottom: "5px",
                }}
              >
                Check-in and Check-out
              </div>
              <div style={{ fontSize: "20px", color: "#707070" }}>
                Check-in time is 03:00 PM
              </div>
              <div style={{ fontSize: "20px", color: "#707070" }}>
                Check-out time is 10:00 AM
              </div>

              <hr style={{ color: "#E7E7E7" }} />

              <div
                style={{
                  fontSize: "25px",
                  fontWeight: "bold",
                  paddingBottom: "5px",
                }}
              >
                House rules and a cancellation policy
              </div>
              <div style={{ fontSize: "20px", color: "#707070" }}>
                {prop.houseRules}
                <br />
                we'll make every effort to work with property management to find
                options if your
                <br />
                plans change but refunds cannot be guaranteed and and on a
                best-effort basis.
                <br />
                <br />
                <div className="link18-bold">
                  Click here to view complete property terms & conditions
                </div>
              </div>

              <hr style={{ color: "#E7E7E7" }} />
            </div>
          </div>


            <Row style={{ alignItems: "flex-start" }}>
              <div className="property-page-body-top-price">{prop.basePrice}</div>
              <div className="property-page-body-top-night">/ Night</div>
            </Row>

            <Row style={{ padding: "20px 0" }}>
              <div className="property-page-body-top-commission-price">
              {prop.basePrice/10}
              </div>
              <div className="property-page-body-top-commission-title">
                &nbsp;&nbsp;Agency Commission
              </div>
            </Row>
        </div>

        <div style={{ padding: "0 40px" }}>
          <div
            style={{
              color: "#284768",
              fontSize: "25px",
              fontWeight: "bold",
              paddingBottom: "5px",
            }}
          >
            Location
          </div>

          <div style={{ height: "100vh", width: "100%" }}>
            <LoadScript googleMapsApiKey="AIzaSyA6TmWVrRTP93bEIGqQG9e_1qvVwcwNJ2k">
              <GoogleMap
                id="marker-example"
                mapContainerStyle={{ width: "100%", height: "400px" }}
                zoom={12}
                center={center}
              >
                <Marker onLoad={onLoad} position={position} />
              </GoogleMap>
            </LoadScript>
          </div>
        </div>
      </div>
            </div>
            </div>
  );
};

export default PropertyEdit;
